import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';

import { getExam, createExamAttempt, getExamAttemptsByExamByUser, finishExamAttempt } from './services/db';

export default function Exam({ examSelected }) {

    // const [value, setValue] = React.useState(0);
    const [exam, setExam] = React.useState({})
    // const [attemptId, setAttemptId] = React.useState('')
    const blFinalizeExam = async () => {
        if(!examSelected.attempt){
            global.closeExam()
            return
        }
        let formdata = new FormData();
        formdata.append("qualification", '-');
        formdata.append("key", localStorage.getItem('klarwayProctoringKey'));
        // formdata.append("examstatus", 1);
        // formdata.append("force", 1);

        let myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem("token"));
        myHeaders.append("Agent", "Klarway-ext");

        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
        };
        await finishExamAttempt(examSelected.attempt.id)

        fetch(`${localStorage.getItem("k_url")}/blFinalizeExam/v2`, requestOptions)
            .then(response => response.json())
            .then(result => {
                // console.log('blFinalizeExam result!', result)
                if (result.success) {
                    // console.log('SE GUARDA una nueva  K:', result.nk)
                    localStorage.setItem('klarwayProctoringKey', result.nk)
                    global.closeExam()
                }
            })
            .catch(error => console.log('blFinalizeExam error', error));
    };

    React.useEffect(() => {
        if (!examSelected) return;
        let active = true;
        const loadExam = async () => {
            try {
                const examFB = await getExam(examSelected.examId, examSelected.courseId);
                if (!active) return;
                
                setExam(examFB)
                // let attempt = await createExamAttempt({userId:localStorage.getItem("user"), examId: examSelected.examId, courseId: examSelected.courseId, environment:localStorage.getItem("env")})
                // console.log(attempt)
                // setAttemptId(attempt.id)

                // let numAttempts = await getExamAttemptsByExamByUser(examSelected.examId, localStorage.getItem("user"), localStorage.getItem("env"))
                // console.log(numAttempts, numAttempts.length)
                // setAttempt(numAttempts.length)
            } catch (error) {
                console.error('Error obteniendo examen', error);
            }
        };

        loadExam();
        return () => {
            active = false;
        };
    }, [examSelected]);


    return (
        <Container component="main" maxWidth="sm" sx={{ mb: 4, mt: 4 }}>
            <Paper variant="outlined" sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}>
                <Typography component="h1" variant="h4" align="center"> {exam?.name ?? 'Examen'} </Typography>
                {/* <Form value={(x) => { setValue(x) }} /> */}
                <Typography variant="h6" gutterBottom>Preguntas: </Typography>
                <Grid container spacing={3}>
                    {exam.questions?.map((question) => (
                        <Grid item xs={12}>
                            <FormControl>
                                <FormLabel id="demo-radio-buttons-group-label">{ question.question }</FormLabel>
                                <RadioGroup aria-labelledby="demo-radio-buttons-group-label" name="radio-buttons-group"
                                    // onChange={(x) => {
                                    //     props.value(x.nativeEvent.target.value)
                                    // }}
                                >
                                    <FormControlLabel value="true" control={<Radio />} label="True" />
                                    <FormControlLabel value="false" control={<Radio />} label="False" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    ))}
                </Grid>
                <React.Fragment>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            variant="contained"
                            sx={{ mt: 3, ml: 1 }}
                            onClick={() => {
                                blFinalizeExam()
                            }}
                        >
                            Finalizar
                        </Button>
                    </Box>
                </React.Fragment>
            </Paper>
        </Container>
    );
}
